import { render, staticRenderFns } from "./BDXStatusPendingWrapper.vue?vue&type=template&id=373e0db1&scoped=true"
import script from "./BDXStatusPendingWrapper.vue?vue&type=script&lang=js"
export * from "./BDXStatusPendingWrapper.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusPendingWrapper.vue?vue&type=style&index=0&id=373e0db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e0db1",
  null
  
)

export default component.exports